<i-title styleClass="w-100" [text]="'courrier.addAttachments' | translate" [buttons]="titleButtons" level="1"></i-title>

<form [formGroup]="form" class="mt-3 mb-3 form modal-body">
  <div class="row">
    @if (filesArray.length > 0) {
      <div class="col-md-12 p-fluid">
        @if (filesNames.length > 0) {
          <div class="alert alert-primary mt-3">
            {{ 'courrier.selectedFiles' | translate }} :
            @for (item of filesNames; track item; let i = $index) {
              <span class="d-inline-block"> {{ item }}{{ i !== filesNames.length - 1 ? ',&nbsp;' : '' }} </span>
            }
          </div>
        }
        <label class="super-compos-label-input">{{ 'file' | translate }}</label>
        <i-table
          [items]="filesArray"
          [paginator]="false"
          [columns]="columns"
          id="super-table-attachementIds"
          class="super-table"
          [forselectionDefaultOption]="false"
          [reorder]="true"
          [multiselect]="true"
          [forselection]="forselection"></i-table>
      </div>
    }
  </div>
</form>
